export class AuditModel {
  Cliente?: string;
  Token?: string;
  IdAcceso?: string;
  TipoAcceso?: number;
  UsuarioFinal?: string;

  clear() {
    this.Cliente = '';
    this.Token = '';
    this.IdAcceso = '';
    this.TipoAcceso = 0;
    this.UsuarioFinal = '';
  }
}
